import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "../api";

export default function NewsletterUnsubscribe() {
  const location = useLocation();
  const [status, setStatus] = useState({ loading: true, error: "", ok: false });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const tail = location.pathname.split("/newsletter/unsubscribe/")[1] || "";
    const tailDecoded = decodeURIComponent(tail);
    if (!token && tailDecoded && /newsletter=unsubscribed/.test(tailDecoded)) {
      setStatus({ loading: false, error: "", ok: true });
      return;
    }
    if (!token) {
      setStatus({ loading: false, error: "Token fehlt.", ok: false });
      return;
    }
    (async () => {
      try {
        await api.get("/newsletter/unsubscribe", { params: { token, json: 1 }, headers: { Accept: "application/json" } });
        setStatus({ loading: false, error: "", ok: true });
      } catch (e) {
        const msg = e?.response?.data?.error || "Abmeldung fehlgeschlagen";
        setStatus({ loading: false, error: msg, ok: false });
      }
    })();
  }, [location.pathname]);

  if (status.loading) return <div style={{ padding: 24 }}><h2 style={{ marginTop: 0 }}>Verarbeite Abmeldung…</h2><p>Bitte einen Moment…</p></div>;
  if (status.ok) {
    return (
      <div className="highlight-card" style={{ maxWidth: 720, margin: '40px auto', padding: 24 }}>
        <h2 className="highlight-title" style={{ marginTop: 0 }}>Newsletter abgemeldet</h2>
        <p>Du hast dich erfolgreich vom AP‑Network Newsletter abgemeldet.</p>
        <Link to="/" className="hero-btn-primary" style={{ display: 'inline-block', marginTop: 8 }}>Zur Startseite</Link>
      </div>
    );
  }
  return (
    <div className="highlight-card" style={{ maxWidth: 720, margin: '40px auto', padding: 24 }}>
      <h2 className="highlight-title" style={{ marginTop: 0 }}>Newsletter‑Abmeldung</h2>
      <p style={{ color: '#ef4444' }}>{status.error}</p>
      <Link to="/" className="hero-btn-secondary" style={{ display: 'inline-block', marginTop: 8 }}>Zur Startseite</Link>
    </div>
  );
}
